export default "__VITE_ASSET__BCmz0qAK__"